(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
function openRoarQuantityOffer(force = false) {
  if (force !== true && location.hash !== '#mangderbjudande') return;
  const target = document.getElementById('mangderbjudande');
  if (!target) return;
  const details = target.querySelector('details');
  if (details) {
    details.open = true;
    details.setAttribute('aria-expanded', 'true');
  }
  requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openRoarQuantityOffer);
else openRoarQuantityOffer();
window.addEventListener('hashchange', openRoarQuantityOffer);
document.addEventListener('click', event => {
  const link = event.target.closest('a[href$="#mangderbjudande"]');
  if (!link || !document.getElementById('mangderbjudande')) return;
  event.preventDefault();
  history.replaceState(null, '', '#mangderbjudande');
  openRoarQuantityOffer(true);
});
document.addEventListener('shopify:section:load', openRoarQuantityOffer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roar-campaign-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('roar-campaign-carousel')) {
  customElements.define('roar-campaign-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('.rs-hero__slide')];
      this.buttons = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(Number(button.dataset.slide)), options));
      this.addEventListener('keydown', event => {
        if (!this.buttons.length || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.buttons[this.index].focus();
      }, options);
      this.addEventListener('pointerdown', event => { this.startX = event.clientX; this.startY = event.clientY; }, options);
      this.addEventListener('pointerup', event => {
        if (!this.buttons.length || this.startX === undefined) return;
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + (dx < 0 ? 1 : -1));
        this.startX = undefined;
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.rs-hero__slide');
        if (slide) this.select(this.slides.indexOf(slide));
      }, options);
      this.select(0);
    }
    disconnectedCallback() { this.controller?.abort(); }
    select(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.classList.toggle('is-selected', i === this.index); slide.inert = i !== this.index; });
      this.buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roar-design-collections"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('.rs-home-collections scroll-carousel:not([data-captions-ready])').forEach((rail) => {
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(({target, intersectionRatio}) => target.classList.toggle('rs-card-in-view', intersectionRatio >= 0.85));
      }, {root:rail, threshold:[0,0.85,1]});
      rail.querySelectorAll('.collection-card').forEach((card) => observer.observe(card));
      rail.dataset.captionsReady = '';
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-hub-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-link-groups')) {
    customElements.define('rs-link-groups', class extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 699px)');
        this.syncViewport = () => {
          this.querySelectorAll('.rs-seo-hub__group').forEach(group => {
            group.open = !this.mobileQuery.matches;
          });
        };
        this.syncViewport();
        this.mobileQuery.addEventListener('change', this.syncViewport);
      }
      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.syncViewport);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
